/**
 * TimeHelper - Helper pour gérer le temps dans le système Escape
 * Identique à Java TimeHelper
 */

export class TimeHelper {
  /**
   * Formate le temps en heures, minutes et secondes
   */
  static formatTime(elapsedSeconds: number): string {
    const elapsedHours = Math.floor(elapsedSeconds / 3600);
    let remainingSeconds = elapsedSeconds % 3600;
    const elapsedMinutes = Math.floor(remainingSeconds / 60);
    remainingSeconds = remainingSeconds % 60;

    if (elapsedHours > 0) {
      return `${elapsedHours}h ${elapsedMinutes}m ${remainingSeconds}s`;
    }
    return `${elapsedMinutes}m ${remainingSeconds}s`;
  }

  /**
   * Formate le temps restant pour l'affichage (format MM:SS ou HH:MM:SS)
   */
  static formatTimeRemaining(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
}
